export default {"src":"/_next/static/media/logo-fonts-dark-v2.59f30776.svg","height":23,"width":120,"blurWidth":0,"blurHeight":0};